import { render } from "./grouppermissions.vue?vue&type=template&id=6a873d3b&scoped=true"
import script from "./grouppermissions.vue?vue&type=script&lang=js"
export * from "./grouppermissions.vue?vue&type=script&lang=js"

import "./grouppermissions.vue?vue&type=style&index=0&id=6a873d3b&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a873d3b"]])

export default __exports__